<template>
  <div style="padding: 15px; scrollbar-width: thin; -ms-overflow-style: none;">
    <v-card color="border" elevation="0" rounded="0" style="padding: 15px;">
      <v-expansion-panels v-model="navigation.searchVisible">
        <v-expansion-panel value="searchVisible">
          <v-expansion-panel-title color="borderInner">
            <p style="font-size: larger;">Búsqueda de seguimientos</p>
            <template v-slot:actions>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom" text="Copiar búsqueda al portapapeles">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click.stop="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de seguimientos', 'a', null)" color="primary" class="hoverableElement" style="margin-right: 5px; cursor: pointer;">mdi-share-variant</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom" :text="`${navigation.searchPinned ? 'Desfijar' : 'Fijar'} panel de búsqueda`">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click.stop="navigation.searchPinned = !navigation.searchPinned; updateURL();" color="primary" class="hoverableElement" style="margin-right: 5px; cursor: pointer;">mdi-{{ navigation.searchPinned ? 'pin-off' : 'pin' }}</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom" text="Buscar">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click.stop="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)" color="primary" class="hoverableElement" style="margin-right: 5px; cursor: pointer;">mdi-magnify</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom" text="Limpiar búsqueda">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click.stop="setDefaultValues()" color="primary" class="hoverableElement" style="cursor: pointer;">mdi-backspace</v-icon>
                </template>
              </v-tooltip>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div style="display: flex;">
              <v-tooltip open-delay="2000" :disabled="systemInformationData.tooltipDisabled" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-switch v-bind="props" v-model="input.filterLogicConnector" true-value="AND" false-value="OR" :label="input.filterLogicConnector == 'AND' ? 'Filtros acumulables' : 'Filtros excluyentes'" color="primary" hide-details style="margin-left: auto; margin-right: 10px;"></v-switch>
                </template>
                <span style="max-width: 400px; display: block;">Si los filtros se aplican en forma acumulable, se buscarán todos los seguimientos que coincidan con TODOS los filtros aplicados. Si los filtros se aplican en forma excluyente, se buscarán todos los seguimientos que coincidan con AL MENOS UNO de los filtros aplicados</span>
              </v-tooltip>
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 20px;">
              <div style="flex: 1; min-width: 300px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
                  <template v-slot:activator="{ props }">
                    <v-text-field 
                      v-bind="props"
                      ref="CRMWhatsappContactFollowupID"
                      v-model="input.CRMWhatsappContactFollowupID"
                      @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                      @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
                      @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupID'); input.CRMWhatsappContactFollowupID = null;" 
                      :append-inner-icon="input.CRMWhatsappContactFollowupID && /\S/.test(input.CRMWhatsappContactFollowupID) ? 'mdi-barcode-off' : 'mdi-barcode'" 
                      type="number"
                      label="Filtrar por identificador interno del seguimiento"
                      variant="solo-filled" 
                      density="compact"
                      autocomplete="off"
                      hide-spin-buttons
                    >
                    </v-text-field>
                  </template>
                  <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática al seguimiento. Si se coloca un identificador interno, se buscará el único seguimiento que coincida con el mismo, ignorando el resto de filtros seleccionados. Al presionar el ícono de la derecha se limpiará el identificador interno colocado</span>
                </v-tooltip>
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
                  <template v-slot:activator="{ props }">
                    <v-autocomplete 
                      v-bind="props"
                      ref="CRMWhatsappContactFollowupCreationCRMAgentID"
                      v-model="input.CRMWhatsappContactFollowupCreationCRMAgentID"
                      v-model:search="input.CRMWhatsappContactFollowupCreationCRMAgentSearch"
                      :items="systemInformationData.CRMAgents"
                      item-title="CRMAgentName"
                      item-value="CRMAgentID"
                      @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                      @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupCreationCRMAgentID'); input.CRMWhatsappContactFollowupCreationCRMAgentSearch = null; input.CRMWhatsappContactFollowupCreationCRMAgentID.length = 0;" 
                      :append-inner-icon="(input.CRMWhatsappContactFollowupCreationCRMAgentSearch && /\S/.test(input.CRMWhatsappContactFollowupCreationCRMAgentSearch)) || input.CRMWhatsappContactFollowupCreationCRMAgentID.length > 0 ? 'mdi-account-off' : 'mdi-account-plus'" 
                      label="Filtrar por agente de creación del seguimiento" 
                      variant="solo-filled" 
                      density="compact"
                      :hide-no-data="true"
                      multiple
                      chips
                      closable-chips
                      autocomplete="off"
                    >
                    </v-autocomplete>
                  </template>
                  <span style="max-width: 400px; display: block;">El agente de creación del seguimiento. Si se coloca un agente, se buscarán todos los seguimientos creados por el o los agentes seleccionados. Al presionar el ícono de la derecha se limpiará el o los agentes seleccionados</span>
                </v-tooltip>
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
                  <template v-slot:activator="{ props }">
                    <v-autocomplete 
                      v-bind="props"
                      ref="CRMWhatsappContactFollowupCompletionCRMAgentID"
                      v-model="input.CRMWhatsappContactFollowupCompletionCRMAgentID"
                      v-model:search="input.CRMWhatsappContactFollowupCompletionCRMAgentSearch"
                      :items="systemInformationData.CRMAgents"
                      item-title="CRMAgentName"
                      item-value="CRMAgentID"
                      @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                      @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupCompletionCRMAgentID'); input.CRMWhatsappContactFollowupCompletionCRMAgentSearch = null; input.CRMWhatsappContactFollowupCompletionCRMAgentID.length = 0;" 
                      :append-inner-icon="(input.CRMWhatsappContactFollowupCompletionCRMAgentSearch && /\S/.test(input.CRMWhatsappContactFollowupCompletionCRMAgentSearch)) || input.CRMWhatsappContactFollowupCompletionCRMAgentID.length > 0 ? 'mdi-account-off' : 'mdi-account-check'" 
                      label="Filtrar por agente de finalización del seguimiento" 
                      variant="solo-filled" 
                      density="compact"
                      :hide-no-data="true"
                      multiple
                      chips
                      closable-chips
                      autocomplete="off"
                    >
                    </v-autocomplete>
                  </template>
                  <span style="max-width: 400px; display: block;">El agente de finalización del seguimiento. Si se coloca un agente, se buscarán todos los seguimientos finalizados por el o los agentes seleccionados. Al presionar el ícono de la derecha se limpiará el o los agentes seleccionados</span>
                </v-tooltip>
              </div>
              <div style="flex: 1; min-width: 300px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
                  <template v-slot:activator="{ props }">
                    <v-autocomplete 
                      v-bind="props"
                      ref="CRMWhatsappContactID"
                      v-model="input.CRMWhatsappContactID"
                      v-model:search="input.CRMWhatsappContactSearch"
                      :loading="loader.autocompleteCRMWhatsappContact"
                      @input="autocompleteCRMWhatsappContact()"
                      :items="display.CRMWhatsappContactOptions"
                      item-title="CRMWhatsappContactName"
                      item-value="CRMWhatsappContactID"
                      @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(false)"
                      @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactID'); input.CRMWhatsappContactSearch = null; input.CRMWhatsappContactID = null;" 
                      :append-inner-icon="(input.CRMWhatsappContactSearch && /\S/.test(input.CRMWhatsappContactSearch)) || input.CRMWhatsappContactID ? 'mdi-account-off' : 'mdi-account'" 
                      label="Filtrar por contacto asignado al seguimiento" 
                      variant="solo-filled" 
                      density="compact"
                      :hide-no-data="true"
                      autocomplete="off"
                    >
                    </v-autocomplete>
                  </template>
                  <span style="max-width: 400px; display: block;">El contacto asignado al seguimiento. Si se coloca un contacto, se buscaran todos los seguimientos asignados al contacto seleccionado. Al presionar el ícono de la derecha se limpiará el contacto seleccionado</span>
                </v-tooltip>
                <v-date-input
                  ref="CRMWhatsappContactFollowupCreationDatetime"
                  v-model="input.CRMWhatsappContactFollowupCreationDatetime"
                  @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                  @click:append-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupCreationDatetime'); input.CRMWhatsappContactFollowupCreationDatetime.length = 0;" 
                  :append-inner-icon="input.CRMWhatsappContactFollowupCreationDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar-plus'" 
                  prepend-icon=""
                  display="keyboardDate"
                  label="Filtrar por fecha de creación del seguimiento"
                  variant="solo-filled"
                  density="compact"
                  multiple="range"
                  autocomplete="off"
                  min="2025-01-01"
                  max="2030-12-31"
                ></v-date-input>
                <v-date-input
                  ref="CRMWhatsappContactFollowupCompletionDatetime"
                  v-model="input.CRMWhatsappContactFollowupCompletionDatetime"
                  @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                  @click:append-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupCompletionDatetime'); input.CRMWhatsappContactFollowupCompletionDatetime.length = 0;" 
                  :append-inner-icon="input.CRMWhatsappContactFollowupCompletionDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar-check'" 
                  prepend-icon=""
                  display="keyboardDate"
                  label="Filtrar por fecha de finalización del seguimiento"
                  variant="solo-filled"
                  density="compact"
                  multiple="range"
                  autocomplete="off"
                  min="2025-01-01"
                  max="2030-12-31"
                ></v-date-input>  
              </div>
            </div>
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
              <template v-slot:activator="{ props }">
                <v-autocomplete 
                  v-bind="props"
                  ref="CRMWhatsappContactFollowupStatus"
                  v-model="input.CRMWhatsappContactFollowupStatus"
                  v-model:search="input.CRMWhatsappContactFollowupStatusSearch"
                  :items="['Pendiente (esperando al contacto)', 'Pendiente (esperando stock)', 'Pendiente (otro)', 'Completado', 'Cancelado']"
                  @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                  @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupStatus'); input.CRMWhatsappContactFollowupStatusSearch = null; input.CRMWhatsappContactFollowupStatus.length = 0;" 
                  :append-inner-icon="(input.CRMWhatsappContactFollowupStatusSearch && /\S/.test(input.CRMWhatsappContactFollowupStatusSearch)) || input.CRMWhatsappContactFollowupStatus.length > 0 ? 'mdi-source-branch-remove' : 'mdi-source-branch'" 
                  label="Filtrar por estado del seguimiento" 
                  variant="solo-filled" 
                  density="compact"
                  :hide-no-data="true"
                  multiple
                  chips
                  closable-chips
                  autocomplete="off"
                >
                </v-autocomplete>
              </template>
              <span style="max-width: 400px; display: block;">El estado del seguimiento indica el estado actual o final del seguimiento. Si se coloca un estado, se buscarán todos los seguimientos que coincidan con el o los estados seleccionados. Al presionar el ícono de la derecha se limpiará el o los estados seleccionados</span>
            </v-tooltip>
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
              <template v-slot:activator="{ props }">
                <v-textarea
                  v-bind="props"
                  ref="CRMWhatsappContactFollowupNote"
                  v-model="input.CRMWhatsappContactFollowupNote"
                  @keydown.enter.prevent="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                  @click:append-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupNote'); input.CRMWhatsappContactFollowupNote = null;" 
                  :append-inner-icon="input.CRMWhatsappContactFollowupNote && /\S/.test(input.CRMWhatsappContactFollowupNote) ? 'mdi-text-box-remove' : 'mdi-text-box'" 
                  label="Filtrar por nota del seguimiento"
                  variant="solo-filled"
                  rows="2"
                  max-rows="4"
                  auto-grow
                  autocomplete="off"
                ></v-textarea>
              </template>
              <span style="max-width: 400px; display: block;">La nota del seguimiento. Si se coloca una nota, se buscarán todos los seguimientos cuya nota coincida con la nota colocada. Al presionar el ícono de la derecha se limpiará la nota colocada</span>
            </v-tooltip>
            <div style="margin-top: 50px;">
              <div :style="{
                display: 'flex',
                flexDirection: $vuetify.display.smAndDown ? 'column' : 'row',
                gap: $vuetify.display.smAndDown ? '10px' : '20px',
                marginBottom: '10px',
                width: '100%',
                justifyContent: 'center'
              }">
                <v-btn 
                  @click="selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(false)"
                  :disabled="loader.selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView" 
                  dark
                  :width="$vuetify.display.smAndDown ? '100%' : '50%'"
                  height="38" 
                  color="primary"
                >
                  <h3>BUSCAR</h3>
                  <v-icon dark right style="margin-left: 10px;">mdi-magnify</v-icon>
                </v-btn>
                <v-tooltip open-delay="2000" location="top" :style="{ width: $vuetify.display.smAndDown ? '100%' : '45%' }">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      v-bind="props" 
                      @click="setDefaultValues()" 
                      :disabled="loader.selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView" 
                      dark
                      :width="$vuetify.display.smAndDown ? '100%' : '50%'"
                      height="38" 
                      color="secondary"
                    >
                      <h3>LIMPIAR BÚSQUEDA</h3>
                      <v-icon dark right style="margin-left: 10px;">mdi-backspace</v-icon>
                    </v-btn>
                  </template>
                  <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
                </v-tooltip>
              </div>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <div v-if="display.CRMWhatsappContactFollowupsBackup.length > 0">
      <br>
      <v-card color="border" elevation="0" rounded="0" style="padding: 15px;">
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="bottom">
            <template v-slot:activator="{ props }">
              <v-text-field 
                v-bind="props"
                ref="searchQuery"
                v-model="input.searchQuery" 
                @input="input.searchQuery != null && /\S/.test(input.searchQuery) ? filterCRMWhatsappContactFollowupsBySearchQuery() : null"
                @click:append-inner="$generalFunctions.default.blurInput(this, 'searchQuery'); input.searchQuery = null; clearFilterOptions(); filterCRMWhatsappContactFollowupsBySearchQuery()" 
                :append-inner-icon="input.searchQuery && /\S/.test(input.searchQuery) ? 'mdi-magnify-remove-outline' : 'mdi-magnify'" 
                label="Búsqueda rápida" 
                variant="solo-filled" 
                density="compact"
                autocomplete="off"
                hide-details
                style="width: 33%;"
              ></v-text-field>
            </template>
            <span style="max-width: 400px; display: block;">La búsqueda rápida permite buscar en toda la lista de seguimientos por identificador interno, nombre del contacto, número de contacto, estado, nota, agente de inicio, agente de finalización, código de producto y nombre de producto. Se buscarán todos los seguimientos que coincidan parcial o completamente con el criterio de búsqueda colocado. Al presionar el ícono de la derecha se eliminará el criterio de búsqueda colocado</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-select
                v-bind="props" 
                v-model="input.filterOptions" 
                :items="[1]"
                ref="filterOptions"
                @click:append-inner="$generalFunctions.default.blurInput(this, 'filterOptions'); clearFilterOptions(); input.searchQuery = null;" 
                :append-inner-icon="input.filterOptions.length == 0 ? 'mdi-filter-variant' : 'mdi-filter-variant-remove'" 
                multiple 
                chips 
                closable-chips
                hide-details
                label="Filtrar por" 
                variant="solo-filled" 
                density="compact"
                autocomplete="off"
                style="width: 33%;"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props">
                    <template v-slot:close>
                      <v-icon @click="input.filterOptions.find((filterOption) => filterOption.title == item.raw.title) ? input.filterOptions.splice(input.filterOptions.findIndex((filterOption) => filterOption.title == item.raw.title), 1) : input.filterOptions.push(item.raw); updateFilterOptions()" color="primary">mdi-close-circle</v-icon>
                    </template>
                    {{ item.raw.title }}
                  </v-chip>
                </template>
                <template v-slot:item>
                  <v-treeview
                    :items="display.filterOptions"
                    fluid
                    density="compact"
                    selectable
                    expand-icon="mdi-chevron-right"
                    collapse-icon="mdi-chevron-down"
                  >
                  <template v-slot:item="{ item }">
                    <v-list-item density="compact" @click="input.filterOptions.find((filterOption) => filterOption.title == item.title) ? input.filterOptions.splice(input.filterOptions.findIndex((filterOption) => filterOption.title == item.title), 1) : input.filterOptions.push(item); item.checked = !item.checked; updateFilterOptions()">
                      <v-chip v-if="item.title.includes('Agente de creación:') || item.title.includes('Agente de finalización:')" :color="item.color || 'primary'" variant="flat" style="cursor: pointer; user-select: none;">
                        <img :src="item.profilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                        <p :style="{ color: item.fontColor || '', margin: 0 }">{{ item.subtitle || 'No registrado' }}</p>
                      </v-chip>
                      <p v-else>{{ item.subtitle }} </p>
                      <template v-slot:prepend>
                        <v-checkbox v-model="item.checked" @update:model-value="input.filterOptions.find((filterOption) => filterOption.title == item.title) ? input.filterOptions.splice(input.filterOptions.findIndex((filterOption) => filterOption.title == item.title), 1) : input.filterOptions.push(item); updateFilterOptions()" hide-details density="compact" style="margin-right: 10px;"></v-checkbox>
                      </template>
                    </v-list-item>
                  </template>
                </v-treeview>
                </template>
              </v-select>
            </template>
            <span style="max-width: 400px; display: block;">Este espacio permite selección múltiple para filtrar por varios criterios en paralelo, mostrando solo las conversaciones que coincidan con todos los criterios de filtrado seleccionados. Al presionar el ícono de la derecha se eliminan todos los criterios de filtrado seleccionados</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-autocomplete
                v-bind="props" 
                ref="sortOptions"
                v-model="input.sortOptions" 
                :items="display.sortOptions" 
                @update:modelValue="updateSortOptions()"
                @click:append-inner="$generalFunctions.default.blurInput(this, 'sortOptions'); input.sortOptions.length = 0; updateSortOptions()" 
                :append-inner-icon="input.sortOptions.length == 0 ? 'mdi-sort-variant' : 'mdi-sort-variant-remove'" 
                multiple 
                chips 
                closable-chips
                hide-details
                :disabled="display.CRMWhatsappContactFollowupsBackup.length == 0"
                label="Ordenar por" 
                variant="solo-filled" 
                density="compact"
                autocomplete="off"
                style="width: 33%;"
              ></v-autocomplete>
            </template>
            <span style="max-width: 400px; display: block;">Las conversaciones inicialmente se ordenan por identificador interno. Este espacio permite selección múltiple para ordenar por varios criterios en paralelo, siempre tomando en cuenta el orden de selección de los criterios de ordenamiento (por ejemplo, al seleccionar agente de inicio y luego agente de finalización, ordenará primero por agente de inicio, y luego cada agente de inicio se ordenará por agente de finalización). Al presionar el ícono de la derecha se eliminan todos los criterios de ordenamiento seleccionados</span>
          </v-tooltip>
        </div>
        <v-data-table :headers="display.CRMWhatsappContactFollowupHeaders" :items="display.CRMWhatsappContactFollowups" :items-per-page="-1" fixed-header style="max-height: 600px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
          <template v-slot:header.CRMWhatsappContactFollowupID>
            <p><strong>ID</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactID>
            <p><strong>CONTACTO</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupStatus>
            <p><strong>ESTADO</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupCreationCRMAgentName>
            <p><strong>CREADO POR</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupCreationDatetime>
            <p><strong>CREADO EL</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupNote>
            <p><strong>NOTA</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupCompletionCRMAgentName>
            <p><strong>FINALIZADO POR</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupCompletionDatetime>
            <p><strong>FINALIZADO EL</strong></p>
          </template>
          <template v-slot:header.CRMWhatsappContactFollowupUpdateCRMAgentName>
            <p><strong>ACTUALIZACIÓN</strong></p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupID="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID del seguimiento al portapapeles" location="top">
              <template v-slot:activator="{ props }">
                <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, `ID del seguimiento`, 'o', item.CRMWhatsappContactFollowupID)" class="hoverableElement" style="cursor: pointer; user-select: none;"><strong>{{ item.CRMWhatsappContactFollowupID }}</strong></p>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactID="{ item }">
            <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(item) }}</p>
            <p style="font-size: smaller; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.CRMWhatsappContactPhoneNumber, false) }}</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupStatus="{ item }">
            <div style="display: flex; align-items: center; gap: 8px;">
              <v-icon :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando stock)': 'error', 'Pendiente (otro)': 'error', 'Completado': 'success', 'Cancelado': 'warning'}[item.CRMWhatsappContactFollowupStatus]" size="small">mdi-circle</v-icon>
              <p>{{ item.CRMWhatsappContactFollowupStatus }}</p>
            </div>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupCreationCRMAgentName="{ item }">
            <v-chip :color="item.CRMWhatsappContactFollowupCreationCRMAgentColor || 'primary'" variant="flat" style="user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="item.CRMWhatsappContactFollowupCreationCRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <p :style="{ color: item.CRMWhatsappContactFollowupCreationCRMAgentFontColor || '', margin: 0 }">{{ item.CRMWhatsappContactFollowupCreationCRMAgentName || 'No registrado' }}</p>
              </div>
            </v-chip>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupCreationDatetime="{ item }">
            <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFollowupCreationDatetime) }}</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupNote="{ item }">
            <p style="max-width: 200px; white-space: nowrap;">{{ item.CRMWhatsappContactFollowupNote && /\S/.test(item.CRMWhatsappContactFollowupNote) ? item.CRMWhatsappContactFollowupNote : 'Sin nota' }}</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupCompletionCRMAgentName="{ item }">
            <v-chip v-if="item.CRMWhatsappContactFollowupCompletionCRMAgentID != null" :color="item.CRMWhatsappContactFollowupCompletionCRMAgentColor || 'primary'" variant="flat" style="user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="item.CRMWhatsappContactFollowupCompletionCRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <p :style="{ color: item.CRMWhatsappContactFollowupCompletionCRMAgentFontColor || '', margin: 0 }">{{ item.CRMWhatsappContactFollowupCompletionCRMAgentName || 'No registrado' }}</p>
              </div>
            </v-chip>
            <p v-else>NA</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupCompletionDatetime="{ item }">
            <p>{{ item.CRMWhatsappContactFollowupCompletionDatetime != null ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFollowupCompletionDatetime) : 'NA' }}</p>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupUpdateCRMAgentName="{ item }">
            <v-chip :color="item.CRMWhatsappContactFollowupUpdateCRMAgentColor || 'primary'" variant="flat" style="cursor: default; user-select: none;">
              <div style="display: flex; align-items: center;">
                <img :src="item.CRMWhatsappContactFollowupUpdateCRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <div style="display: flex; flex-direction: column;">
                  <p :style="item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor ? { color: item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor } : {}" style="margin: 0;">{{ item.CRMWhatsappContactFollowupUpdateCRMAgentName || 'No registrado' }}</p>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-icon size="xx-small" :color="item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor ? item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor : {}">mdi-clock-outline</v-icon>
                    <p style="font-size: xx-small;" :style="{ color: item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor ? item.CRMWhatsappContactFollowupUpdateCRMAgentFontColor : {} }">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactFollowupUpdateDatetime) }}</p>
                  </div>
                </div>
              </div>
            </v-chip>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupProductAction="{ item }">
            <div v-if="item.CRMWhatsappContactFollowupProducts.length > 0">
              <v-menu :close-on-content-click="false" :scrim="true" style="cursor: default; user-select: none;">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="info" class="hoverableElement">mdi-cart</v-icon>
                </template>
                <v-data-table :headers="display.CRMWhatsappContactFollowupProductHeaders" :items="item.CRMWhatsappContactFollowupProducts" :items-per-page="-1" :fixed-header="true" style="max-height: 300px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                  <template v-slot:header.CRMWhatsappContactFollowupProductID>
                    <p><strong>PRODUCTO</strong></p>
                  </template>
                  <template v-slot:header.CRMWhatsappContactFollowupProductAmount>
                    <p><strong>CANTIDAD</strong></p>
                  </template>
                  <template v-slot:item.CRMWhatsappContactFollowupProductID="{ item }">
                    <p>{{ item.CRMWhatsappContactFollowupProductName }}</p>
                    <p style="font-size: smaller; color: #9e9e9e;"><strong>{{ item.CRMWhatsappContactFollowupProductProductID }}</strong></p>
                  </template>
                  <template #bottom></template>
                </v-data-table>
              </v-menu>
            </div>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupSendCRMWhatsappMessageAction="{ item }">
            <v-tooltip v-if="item.CRMWhatsappContactFollowupStatus != 'Completado' && item.CRMWhatsappContactFollowupStatus != 'Cancelado'" :disabled="systemInformationData.tooltipDisabled" text="Escribir al contacto" location="top">
              <template v-slot:activator="{ props }">
                <v-icon @click="$root.dialogComponent.openSendCRMWhatsappMessageToCRMWhatsappContactDialog(item.CRMWhatsappContactID, false)" v-bind="props" color="primary" class="hoverableElement" style="margin-right: 10px; cursor: pointer;">mdi-chat-plus</v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupOpenCreationCRMWhatsappConversationAction="{ item }">
            <v-tooltip v-if="item.CRMWhatsappContactFollowupCreationCRMWhatsappConversationID != null" :disabled="systemInformationData.tooltipDisabled" text="Abrir conversación de creación del seguimiento" location="top">
              <template v-slot:activator="{ props }">
                <v-icon @click="$root.dialogComponent.openCRMWhatsappConversationDialog(item.CRMWhatsappContactFollowupCreationCRMWhatsappConversationID)" v-bind="props" color="indigo" class="hoverableElement" style="margin-right: 10px; cursor: pointer;">mdi-chat-question</v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupEditAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Editar seguimiento" location="top">
              <template v-slot:activator="{ props }">
                <v-icon @click="openCRMWhatsappContactFollowupDialog(item)" v-bind="props" color="warning" class="hoverableElement" style="margin-right: 10px; cursor: pointer;">mdi-pencil</v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.CRMWhatsappContactFollowupDeleteAction="{ item }">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Eliminar seguimiento" location="top">
              <template v-slot:activator="{ props }">
                <v-icon @click="deleteCRMWhatsappContactFollowup(item)" v-bind="props" color="error" class="hoverableElement" style="margin-right: 10px; cursor: pointer;">mdi-delete</v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <div style="text-align: center; padding: 15px; cursor: default; user-select: none;">
              <v-icon size="large" color="grey">mdi-information-outline</v-icon>
              <p v-if="input.searchQuery != null" style="margin-top: 5px; color: grey;">No existen seguimientos con el criterio de búsqueda <strong>"{{ input.searchQuery }}"</strong></p>
              <p v-else style="margin-top: 5px; color: grey;">No existen seguimientos con los criterios de búsqueda o filtros aplicados</p>
              <p v-if="input.searchQuery != null" style="color: grey;">Haz click <span style="cursor: pointer; user-select: none; text-decoration: underline;" @click="input.filterOptions.length = 0; input.sortOptions.length = 0; input.searchQuery = null; display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(display.CRMWhatsappContactFollowupsBackup));">aquí</span> para limpiar el criterio de búsqueda</p>
              <p v-else style="color: grey;">Haz click <span style="cursor: pointer; user-select: none; text-decoration: underline;" @click="input.filterOptions.length = 0; input.sortOptions.length = 0; input.searchQuery = null; display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(display.CRMWhatsappContactFollowupsBackup));">aquí</span> para limpiar los criterios de búsqueda y filtrado</p>
            </div>
          </template>
          <template v-slot:bottom></template>
        </v-data-table>
        <div style="display: flex; justify-content: flex-end; margin-top: 15px;">
          <p style="font-size: smaller; color: #9e9e9e; cursor: default; user-select: none;">Mostrando <strong>{{ display.CRMWhatsappContactFollowups.length }}</strong> de <strong>{{ display.CRMWhatsappContactFollowupsBackup.length }}</strong> seguimientos</p>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
</style>

<script setup>
  import { systemInformation } from '@/utilities/systemInformation';
  import LZString from 'lz-string';
</script>

<script>
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        filterLogicConnector: 'AND',
        CRMWhatsappContactFollowupID: null,
        CRMWhatsappContactID: null,
        CRMWhatsappContactSearch: null,
        CRMWhatsappContactFollowupCreationCRMAgentID: [],
        CRMWhatsappContactFollowupCreationCRMAgentSearch: null,
        CRMWhatsappContactFollowupCreationDatetime: [],
        CRMWhatsappContactFollowupCompletionCRMAgentID: [],
        CRMWhatsappContactFollowupCompletionCRMAgentSearch: null,
        CRMWhatsappContactFollowupCompletionDatetime: [],
        CRMWhatsappContactFollowupStatus: [],
        CRMWhatsappContactFollowupStatusSearch: null,
        CRMWhatsappContactFollowupNote: null,
        searchQuery: null,
        filterOptions: [],
        sortOptions: []
      },
      display: 
      {
        CRMWhatsappContactOptions: [],
        CRMWhatsappContactFollowupHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappContactFollowupID', sortable: false},
          {title: 'CONTACTO', value: 'CRMWhatsappContactID', sortable: false},
          {title: 'ESTADO', value: 'CRMWhatsappContactFollowupStatus', sortable: false},
          {title: 'CREADO POR', value: 'CRMWhatsappContactFollowupCreationCRMAgentName', sortable: false},
          {title: 'CREADO EL', value: 'CRMWhatsappContactFollowupCreationDatetime', sortable: false},
          {title: 'NOTA', value: 'CRMWhatsappContactFollowupNote', sortable: false},
          {title: 'FINALIZADO POR', value: 'CRMWhatsappContactFollowupCompletionCRMAgentName', sortable: false},
          {title: 'FINALIZADO EL', value: 'CRMWhatsappContactFollowupCompletionDatetime', sortable: false},
          {title: 'ACTUALIZACIÓN', value: 'CRMWhatsappContactFollowupUpdateCRMAgentName', sortable: false},
          {title: null, value: 'CRMWhatsappContactFollowupProductAction', sortable: false},
          {title: null, value: 'CRMWhatsappContactFollowupSendCRMWhatsappMessageAction', sortable: false},
          {title: null, value: 'CRMWhatsappContactFollowupOpenCreationCRMWhatsappConversationAction', sortable: false},
          {title: null, value: 'CRMWhatsappContactFollowupEditAction', sortable: false},
          {title: null, value: 'CRMWhatsappContactFollowupDeleteAction', sortable: false}
        ],
        CRMWhatsappContactFollowups: [],
        CRMWhatsappContactFollowupsBackup: [],
        filterOptions:
        [
          {title: 'Agente de creación', children: []},
          {title: 'Agente de finalización', children: []},
          {
            title: 'Estado', 
            children: 
            [
              {title: 'Estado: Pendiente (esperando al contacto)', subtitle: 'Pendiente (esperando al contacto)', filteredField: 'CRMWhatsappContactFollowupStatus', filteredValue: 'Pendiente (esperando al contacto)'},
              {title: 'Estado: Pendiente (esperando stock)', subtitle: 'Pendiente (esperando stock)', filteredField: 'CRMWhatsappContactFollowupStatus', filteredValue: 'Pendiente (esperando stock)'},
              {title: 'Estado: Pendiente (otro)', subtitle: 'Pendiente (otro)', filteredField: 'CRMWhatsappContactFollowupStatus', filteredValue: 'Pendiente (otro)'},
              {title: 'Estado: Completado', subtitle: 'Completado', filteredField: 'CRMWhatsappContactFollowupStatus', filteredValue: 'Completado'},
              {title: 'Estado: Cancelado', subtitle: 'Cancelado', filteredField: 'CRMWhatsappContactFollowupStatus', filteredValue: 'Cancelado'}
            ]
          }
        ],
        sortOptions:
        [
          {title: 'ID (menor a mayor)', value: 'CRMWhatsappContactFollowupID_asc', sortable: false, type: 'number'},
          {title: 'ID (mayor a menor)', value: 'CRMWhatsappContactFollowupID_desc', sortable: false, type: 'number'},
          {title: 'Contacto (A-Z)', value: 'CRMWhatsappContactName_asc', sortable: false, type: 'string'},
          {title: 'Contacto (Z-A)', value: 'CRMWhatsappContactName_desc', sortable: false, type: 'string'},
          {title: 'Estado (A-Z)', value: 'CRMWhatsappContactFollowupStatus_asc', sortable: false, type: 'string'},
          {title: 'Estado (Z-A)', value: 'CRMWhatsappContactFollowupStatus_desc', sortable: false, type: 'string'},
          {title: 'Creado por (A-Z)', value: 'CRMWhatsappContactFollowupCreationCRMAgentName_asc', sortable: false, type: 'string'},
          {title: 'Creado por (Z-A)', value: 'CRMWhatsappContactFollowupCreationCRMAgentName_desc', sortable: false, type: 'string'},
          {title: 'Creado el (más reciente a más antiguo)', value: 'CRMWhatsappContactFollowupCreationDatetime_asc', sortable: false, type: 'datetime'},
          {title: 'Creado el (más antiguo a más reciente)', value: 'CRMWhatsappContactFollowupCreationDatetime_desc', sortable: false, type: 'datetime'},
          {title: 'Finalizado por (A-Z)', value: 'CRMWhatsappContactFollowupCompletionCRMAgentName_asc', sortable: false, type: 'string'},
          {title: 'Finalizado por (Z-A)', value: 'CRMWhatsappContactFollowupCompletionCRMAgentName_desc', sortable: false, type: 'string'},
          {title: 'Finalizado el (más reciente a más antiguo)', value: 'CRMWhatsappContactFollowupCompletionDatetime_asc', sortable: false, type: 'datetime'},
          {title: 'Finalizado el (más antiguo a más reciente)', value: 'CRMWhatsappContactFollowupCompletionDatetime_desc', sortable: false, type: 'datetime'}
        ],
        CRMWhatsappContactFollowupProductHeaders:
        [
          {title: 'PRODUCTO', key: 'CRMWhatsappContactFollowupProductID', sortable: false},
          {title: 'CANTIDAD', key: 'CRMWhatsappContactFollowupProductAmount', sortable: false}
        ]
      },
      navigation: 
      {
        searchPinned: false,
        searchVisible: 'searchVisible'
      },
      loader: 
      {
        autocompleteCRMWhatsappContact: false,
        selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView: false
      },
      asset: {},
      interval: 
      {
        autocompleteCRMWhatsappContactInterval: null,
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMLocalities: [],
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    watch: 
    {
      input:
      {
        handler(){
          this.updateURL();
        },
        deep: true
      }
    },

    methods:
    {
      autocompleteCRMWhatsappContact(){
        if (this.interval.autocompleteCRMWhatsappContactInterval) {
          clearTimeout(this.interval.autocompleteCRMWhatsappContactInterval);
          this.interval.autocompleteCRMWhatsappContactInterval = null;
        }
        if (this.input.CRMWhatsappContactSearch && /\S/.test(this.input.CRMWhatsappContactSearch)){
          this.interval.autocompleteCRMWhatsappContactInterval = setTimeout(async () => {
            this.loader.autocompleteCRMWhatsappContact = true;
            if (!this.input.CRMWhatsappContactSearch) {
              this.display.CRMWhatsappContactOptions.length = 0;
              this.loader.autocompleteCRMWhatsappContact = false;
              this.$generalFunctions.default.blurInput(this, 'CRMWhatsappContactSearch');
              return;
            }
            const autocompleteCRMWhatsappContactRequestQuery =
            {
              'localStorage': 
              {
                'CRMAccountID': this.systemInformationData.CRMAccountID
              },
              'CRMWhatsappContactSearch': this.input.CRMWhatsappContactSearch
            };
            const autocompleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/autocompleteCRMWhatsappContact', autocompleteCRMWhatsappContactRequestQuery);
            if (autocompleteCRMWhatsappContactResult.success) {
              this.display.CRMWhatsappContactOptions = autocompleteCRMWhatsappContactResult.result;
              if (this.display.CRMWhatsappContactOptions.length == 0) this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_noResults', 'info', 'No se ha encontrado ningún contacto con el nombre buscado', null, false);
              else {
                this.display.CRMWhatsappContactOptions.forEach(CRMWhatsappContact => {
                  CRMWhatsappContact.CRMWhatsappContactName = `${CRMWhatsappContact.CRMWhatsappContactName} - ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappContact.CRMWhatsappContactPhoneNumber, false)}`;
                  delete CRMWhatsappContact.CRMWhatsappContactPhoneNumber;
                });
              }
            } else {
              this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al consultar los contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
            }
            this.loader.autocompleteCRMWhatsappContact = false;          
          }, 1000);
        }
      },

      async selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(pageLoad){
        this.display.CRMWhatsappContactFollowups.length = 0;
        this.display.CRMWhatsappContactFollowupsBackup.length = 0;
        if (!pageLoad){
          this.input.searchQuery = null;
          this.input.filterOptions.length = 0;
          this.input.sortOptions.length = 0;
        }
        this.loader.selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView = true;
        const selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsViewRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'filterLogicConnector': this.input.filterLogicConnector,
          'CRMWhatsappContactFollowupID': this.input.CRMWhatsappContactFollowupID,
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMWhatsappContactFollowupCreationCRMAgentID': this.input.CRMWhatsappContactFollowupCreationCRMAgentID,
          'CRMWhatsappContactFollowupCompletionCRMAgentID': this.input.CRMWhatsappContactFollowupCompletionCRMAgentID,
          'CRMWhatsappContactFollowupStatus': this.input.CRMWhatsappContactFollowupStatus,
          'CRMWhatsappContactFollowupNote': this.input.CRMWhatsappContactFollowupNote,
          'CRMWhatsappContactFollowupCreationStartDatetime': this.input.CRMWhatsappContactFollowupCreationDatetime.length > 0 ? this.input.CRMWhatsappContactFollowupCreationDatetime[0] : null,
          'CRMWhatsappContactFollowupCreationEndDatetime': this.input.CRMWhatsappContactFollowupCreationDatetime.length > 0 ? this.input.CRMWhatsappContactFollowupCreationDatetime[this.input.CRMWhatsappContactFollowupCreationDatetime.length - 1] : null,
          'CRMWhatsappContactFollowupCompletionStartDatetime': this.input.CRMWhatsappContactFollowupCompletionDatetime.length > 0 ? this.input.CRMWhatsappContactFollowupCompletionDatetime[0] : null,
          'CRMWhatsappContactFollowupCompletionEndDatetime': this.input.CRMWhatsappContactFollowupCompletionDatetime.length > 0 ? this.input.CRMWhatsappContactFollowupCompletionDatetime[this.input.CRMWhatsappContactFollowupCompletionDatetime.length - 1] : null,
        };
        const selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView', selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsViewRequestQuery);
        if (selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsViewResult.success){
          this.display.CRMWhatsappContactFollowups = selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsViewResult.result;
          this.display.CRMWhatsappContactFollowupsBackup = JSON.parse(JSON.stringify(this.display.CRMWhatsappContactFollowups));

          const CRMWhatsappContactFollowupCreationCRMAgentIDs = new Set();
          this.display.filterOptions[0].children = this.display.CRMWhatsappContactFollowups.filter((CRMWhatsappContactFollowup) => CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentID != null).map((CRMWhatsappContactFollowup) => ({
            'title': 'Agente de creación: ' + CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentName,
            'subtitle': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentName,
            'filteredField': 'CRMWhatsappContactFollowupCreationCRMAgentID',
            'color': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentColor,
            'fontColor': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentFontColor,
            'profilePictureURL': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentProfilePictureURL,
            'filteredValue': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentID
          })).filter((item) => {
            if (CRMWhatsappContactFollowupCreationCRMAgentIDs.has(item.filteredValue)) return false;
            CRMWhatsappContactFollowupCreationCRMAgentIDs.add(item.filteredValue);
            return true;
          });
          const CRMWhatsappContactFollowupCompletionCRMAgentIDs = new Set();
          this.display.filterOptions[1].children = this.display.CRMWhatsappContactFollowups.filter((CRMWhatsappContactFollowup) => CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentID != null).map((CRMWhatsappContactFollowup) => ({
            'title': 'Agente de finalización: ' + CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentName,
            'subtitle': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentName,
            'filteredField': 'CRMWhatsappContactFollowupCompletionCRMAgentID',
            'color': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentColor,
            'fontColor': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentFontColor,
            'profilePictureURL': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentProfilePictureURL,
            'filteredValue': CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentID
          })).filter((item) => {
            if (CRMWhatsappContactFollowupCompletionCRMAgentIDs.has(item.filteredValue)) return false;
            CRMWhatsappContactFollowupCompletionCRMAgentIDs.add(item.filteredValue);
            return true;
          });
          if (this.display.CRMWhatsappContactFollowups.length == 0){
            this.navigation.searchVisible = 'searchVisible';
            this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView_noResults', 'info', 'No se ha encontrado ningún seguimiento con los filtros aplicados', null, false);
          } else {
            this.navigation.searchVisible = this.navigation.searchPinned ? 'searchVisible' : '';
          }
          this.updateFilterOptions();
          this.updateSortOptions();
          this.updateURL();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView_error', 'error', 'Ha ocurrido un error inesperado al consultar la lista de seguimientos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView = false;
      },

      filterCRMWhatsappContactFollowupsBySearchQuery(){
        this.display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(this.display.CRMWhatsappContactFollowupsBackup));
        if (this.input.searchQuery != null && /\S/.test(this.input.searchQuery)){
          this.display.CRMWhatsappContactFollowups = this.display.CRMWhatsappContactFollowups.filter((CRMWhatsappContactFollowup) => 
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupID != null && CRMWhatsappContactFollowup.CRMWhatsappContactFollowupID.toString().includes(this.input.searchQuery) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactName != null && CRMWhatsappContactFollowup.CRMWhatsappContactName.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactPhoneNumber != null && CRMWhatsappContactFollowup.CRMWhatsappContactPhoneNumber.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupStatus != null && CRMWhatsappContactFollowup.CRMWhatsappContactFollowupStatus.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupNote != null && CRMWhatsappContactFollowup.CRMWhatsappContactFollowupNote.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentName != null && CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCreationCRMAgentName.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentName != null && CRMWhatsappContactFollowup.CRMWhatsappContactFollowupCompletionCRMAgentName.toLowerCase().includes(this.input.searchQuery.toLowerCase()) ||
            CRMWhatsappContactFollowup.CRMWhatsappContactFollowupProducts.some(CRMWhatsappContactFollowupProduct => 
              CRMWhatsappContactFollowupProduct.CRMWhatsappContactFollowupProductProductID != null && CRMWhatsappContactFollowupProduct.CRMWhatsappContactFollowupProductProductID.toLowerCase().includes(this.input.searchQuery.toLowerCase())
              ||
              CRMWhatsappContactFollowupProduct.CRMWhatsappContactFollowupProductName != null && CRMWhatsappContactFollowupProduct.CRMWhatsappContactFollowupProductName.toLowerCase().includes(this.input.searchQuery.toLowerCase())
            )
          );
        }
      },

      updateFilterOptions(){
        this.input.searchQuery = null;
        this.display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(this.display.CRMWhatsappContactFollowupsBackup));
        this.display.filterOptions.forEach((filterOption) => {
          filterOption.children.forEach((child) => {
            const inputFilterOption = this.input.filterOptions.find((inputFilterOption) => inputFilterOption.title == child.title);
            child.checked = inputFilterOption != null && inputFilterOption.checked;
          });
        });
        if (this.input.filterOptions.length > 0){
          this.display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(this.display.CRMWhatsappContactFollowupsBackup)).filter((CRMWhatsappContactFollowup) => {
            const groupedFilters = this.input.filterOptions.reduce((acc, filterOption) => {
              if (!acc[filterOption.filteredField]) {
                acc[filterOption.filteredField] = [];
              }
              acc[filterOption.filteredField].push(filterOption.filteredValue);
              return acc;
            }, {});
            return Object.entries(groupedFilters).every(([field, values]) => {
              return values.some(value => CRMWhatsappContactFollowup[field] == value);
            });
          });
        }
      },

      clearFilterOptions(){
        this.input.filterOptions.length = 0;
        this.display.filterOptions.forEach((filterOption) => {
          filterOption.children.forEach((child) => {
            child.checked = false;
          });
        });
        this.display.CRMWhatsappContactFollowups = JSON.parse(JSON.stringify(this.display.CRMWhatsappContactFollowupsBackup));
      },

      updateSortOptions(){
        if (this.input.sortOptions.length > 0){
          const sortOptionsGrouped = {};
          this.input.sortOptions.forEach(sortOption => {
            const sortOptionKey = sortOption.split('_')[0];
            if (!sortOptionsGrouped[sortOptionKey]) {
              sortOptionsGrouped[sortOptionKey] = [];
            }
            sortOptionsGrouped[sortOptionKey].push(sortOption);
          });
          this.input.sortOptions = Object.values(sortOptionsGrouped).map(sortOptionsGroup => sortOptionsGroup[sortOptionsGroup.length - 1]);
          this.display.CRMWhatsappContactFollowups = [...this.display.CRMWhatsappContactFollowups].sort((CRMWhatsappContactFollowupA, CRMWhatsappContactFollowupB) => {
            for (const sortOption of this.input.sortOptions) {
              const displaySortOption = this.display.sortOptions.find(displaySortOption => displaySortOption.value == sortOption);
              if (displaySortOption) {
                let comparison = 0;
                if (displaySortOption.type == 'number' && CRMWhatsappContactFollowupA[sortOption.split('_')[0]] != null && CRMWhatsappContactFollowupB[sortOption.split('_')[0]] != null) comparison = (sortOption.includes('_desc') ? -1 : 1) * (CRMWhatsappContactFollowupA[sortOption.split('_')[0]] - CRMWhatsappContactFollowupB[sortOption.split('_')[0]]);
                else if (displaySortOption.type == 'string' && CRMWhatsappContactFollowupA[sortOption.split('_')[0]] != null && CRMWhatsappContactFollowupB[sortOption.split('_')[0]] != null) comparison = (sortOption.includes('_desc') ? -1 : 1) * (CRMWhatsappContactFollowupA[sortOption.split('_')[0]].localeCompare(CRMWhatsappContactFollowupB[sortOption.split('_')[0]]));
                else if (displaySortOption.type == 'datetime' && CRMWhatsappContactFollowupA[sortOption.split('_')[0]] != null && CRMWhatsappContactFollowupB[sortOption.split('_')[0]] != null) comparison = (sortOption.includes('_desc') ? 1 : -1) * (new Date(CRMWhatsappContactFollowupA[sortOption.split('_')[0]]).getTime() - new Date(CRMWhatsappContactFollowupB[sortOption.split('_')[0]]).getTime());
                if (comparison != 0) return comparison;
              }
            }
            return 0;
          });
        } else {
          this.display.CRMWhatsappContactFollowups = this.display.CRMWhatsappContactFollowups.sort((CRMWhatsappContactFollowupA, CRMWhatsappContactFollowupB) => CRMWhatsappContactFollowupB.CRMWhatsappContactFollowupID - CRMWhatsappContactFollowupA.CRMWhatsappContactFollowupID);
        }
      },

      clearSortOptions(){
        this.input.sortOptions.length = 0;
        this.display.CRMWhatsappContactFollowups = this.display.CRMWhatsappContactFollowups.sort((CRMWhatsappContactFollowupA, CRMWhatsappContactFollowupB) => {
          return CRMWhatsappContactFollowupB.CRMWhatsappContactFollowupID - CRMWhatsappContactFollowupA.CRMWhatsappContactFollowupID;
        });
      },

      setDefaultValues(){
        this.input.filterLogicConnector = 'AND';
        this.input.CRMWhatsappContactFollowupID = null;
        this.input.CRMWhatsappContactID = null;
        this.input.CRMWhatsappContactSearch = null;
        this.input.CRMWhatsappContactFollowupCreationCRMAgentID.length = 0;
        this.input.CRMWhatsappContactFollowupCreationCRMAgentSearch = null;
        this.input.CRMWhatsappContactFollowupCreationDatetime.length = 0;
        this.input.CRMWhatsappContactFollowupCompletionCRMAgentID.length = 0;
        this.input.CRMWhatsappContactFollowupCompletionCRMAgentSearch = null;
        this.input.CRMWhatsappContactFollowupCompletionDatetime.length = 0;
        this.input.CRMWhatsappContactFollowupStatus.length = 0;
        this.input.CRMWhatsappContactFollowupStatusSearch = null;
        this.input.CRMWhatsappContactFollowupNote = null;
        this.input.searchQuery = null;
        this.input.sortOptions.length = 0;
        this.display.CRMWhatsappContactFollowups.length = 0;
        this.display.CRMWhatsappContactFollowupsBackup.length = 0;
        this.updateURL();
      },

      updateURL(){
        let requestQuery = 
        {
          '1': this.input.filterLogicConnector,
          '2': this.input.CRMWhatsappContactFollowupID,
          '3': this.input.CRMWhatsappContactID,
          '4': this.input.CRMWhatsappContactSearch,
          '5': this.input.CRMWhatsappContactID && this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID) ? this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID).CRMWhatsappContactName : null,
          '6': this.input.CRMWhatsappContactFollowupCreationCRMAgentID,
          '7': this.input.CRMWhatsappContactFollowupCreationCRMAgentSearch,
          '8': this.input.CRMWhatsappContactFollowupCompletionCRMAgentID,
          '9': this.input.CRMWhatsappContactFollowupCompletionCRMAgentSearch,
          '10': this.input.CRMWhatsappContactFollowupStatus,
          '11': this.input.CRMWhatsappContactFollowupStatusSearch,
          '12': this.input.CRMWhatsappContactFollowupNote,
          '13': this.input.CRMWhatsappContactFollowupCreationDatetime,
          '14': this.input.CRMWhatsappContactFollowupCompletionDatetime,
          '15': this.input.searchQuery,
          '16': this.input.filterOptions,
          '17': this.input.sortOptions,
          '18': this.navigation.searchPinned,
          '19': this.display.CRMWhatsappContactFollowupsBackup.length > 0,
        };
        requestQuery = Object.fromEntries(Object.entries(requestQuery).filter(([ , v]) => v != null && v != undefined));
        const requestQueryCompressed = LZString.compressToEncodedURIComponent(JSON.stringify(requestQuery));
        this.$router.replace({query: {searchQuery: requestQueryCompressed}});
      },

      async decodeURL(){
        let requestQuery = this.$route.query.searchQuery;
        if (requestQuery){
          requestQuery = JSON.parse(LZString.decompressFromEncodedURIComponent(requestQuery));
          this.input.filterLogicConnector = requestQuery['1'] ?? 'AND';
          this.input.CRMWhatsappContactFollowupID = requestQuery['2'];
          this.input.CRMWhatsappContactID = requestQuery['3'];
          this.input.CRMWhatsappContactSearch = requestQuery['4'];
          this.display.CRMWhatsappContactOptions = requestQuery['3'] && requestQuery['5'] ? [{'CRMWhatsappContactID': requestQuery['3'], 'CRMWhatsappContactName': requestQuery['5']}] : [];
          this.input.CRMWhatsappContactFollowupCreationCRMAgentID = requestQuery['6'] || [];
          this.input.CRMWhatsappContactFollowupCreationCRMAgentSearch = requestQuery['7'];
          this.input.CRMWhatsappContactFollowupCompletionCRMAgentID = requestQuery['8'] || [];
          this.input.CRMWhatsappContactFollowupCompletionCRMAgentSearch = requestQuery['9'];
          this.input.CRMWhatsappContactFollowupStatus = requestQuery['10'] || [];
          this.input.CRMWhatsappContactFollowupStatusSearch = requestQuery['11'];
          this.input.CRMWhatsappContactFollowupNote = requestQuery['12'];
          this.input.CRMWhatsappContactFollowupCreationDatetime = requestQuery['13'] || [];
          this.input.CRMWhatsappContactFollowupCompletionDatetime = requestQuery['14'] || [];
          this.input.searchQuery = requestQuery['15'];
          this.input.filterOptions = requestQuery['16'] || [];
          this.input.sortOptions = requestQuery['17'] || [];
          this.navigation.searchPinned = requestQuery['18'] ?? false;
          if (requestQuery['19']){
            await this.selectCRMWhatsappContactFollowupFromCRMWhatsappContactFollowupsView(true);
          }
        }
      },

      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted(){
      await this.getSystemInformation();
      await this.decodeURL();
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>